export const setParamsTermoResponsabilidade = (params) => {
  sessionStorage.setItem('@termo-reponsabilidade', JSON.stringify(params));
};

export const getParamsTermoResponsabilidade = () => {
  return JSON.parse(sessionStorage.getItem('@termo-reponsabilidade'));
};
